import { render, staticRenderFns } from "./ProductsIndexPage.vue?vue&type=template&id=e85bfb78&scoped=true&"
import script from "./ProductsIndexPage.vue?vue&type=script&lang=js&"
export * from "./ProductsIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsIndexPage.vue?vue&type=style&index=0&id=e85bfb78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85bfb78",
  null
  
)

export default component.exports